import { render, staticRenderFns } from "./u-card-border-point.vue?vue&type=template&id=bef5574a&scoped=true&"
import script from "./u-card-border-point.vue?vue&type=script&lang=js&"
export * from "./u-card-border-point.vue?vue&type=script&lang=js&"
import style0 from "./u-card-border-point.vue?vue&type=style&index=0&id=bef5574a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef5574a",
  null
  
)

export default component.exports